/**
 * Widget Service
 * 위젯 API 서비스
 */

import api from "@/services/api";
import type { Widget, PermissionGroupWidgets } from "@/types/widget";

const widgetService = {
  /**
   * 모든 위젯 목록 조회
   */
  async getWidgets(): Promise<Widget[]> {
    const { data } = await api.get("/widgets");
    return data;
  },

  /**
   * 내가 접근 가능한 위젯 코드 목록
   */
  async getMyWidgets(): Promise<string[]> {
    const { data } = await api.get("/widgets/my-widgets");
    return data;
  },

  /**
   * 권한 그룹의 위젯 목록 조회 (companyId: super_admin 전용 대상 기업 지정)
   */
  async getPermissionGroupWidgets(groupId: number, companyId?: string): Promise<PermissionGroupWidgets> {
    const { data } = await api.get(`/widgets/permission-group/${groupId}`, {
      params: { company_id: companyId },
    });
    return data;
  },

  /**
   * 권한 그룹의 위젯 권한 업데이트
   */
  async updatePermissionGroupWidgets(groupId: number, widgetCodes: string[], companyId?: string): Promise<void> {
    await api.put(`/widgets/permission-group/${groupId}`, widgetCodes, {
      params: { company_id: companyId },
    });
  },
};

export default widgetService;
